import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-flow: column;
  position: relative;
  height: 95%;

  hr {
    margin: 15px 0 10px 0;
    border: 1px solid ${props => props.theme.colors.color6b7786};
  }
`
export const ContainerInformation = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))`
  padding-right: 4px;
  display: flex;
  flex-direction: column;
  flex-flow: column;
  flex: 1 1 auto;

  overflow-y: scroll;
  ${VerticalStyledScrollBar}
`
